import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import messageTemplatesApi from '@/features/dashboard/messageTemplates/api/messageTemplatesApi.ts';
import { MessageTemplateDto } from '@/features/dashboard/messageTemplates/types/MessageTemplateDto.ts';

const useSendTestEmail = () => {
  return useMutation({
    mutationFn: (dto: MessageTemplateDto) =>
      messageTemplatesApi.sendTestEmail(dto.messageTemplateType, dto),
    onSuccess: () => {
      toast.success('Wiadomość testowa została wysłana na Twój adres e-mail');
    },
    onError: (error: Error) => {
      toast.error('Nie udało się wysłać wiadomości testowej', {
        description: error.message,
      });
    },
  });
};

export default useSendTestEmail;
